import { render, staticRenderFns } from "./UserRecommended.vue?vue&type=template&id=2b9abc48&"
import script from "./UserRecommended.vue?vue&type=script&lang=js&"
export * from "./UserRecommended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports